import { errorSafe } from 'app/infrastructure/redux/error-safe';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import * as actions from './action-types';
import { api } from './api';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages/action-types';
import { downloadFile } from 'app/infrastructure/platform/file';

export const actionCreators = {

  loadExportStatus: (): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: () => ApplicationState) => {
      const myDownloadsState = getState().myDownloads;

      if (myDownloadsState.exportsView.fetching) {
        return;
      }

      dispatch(new actions.RequestExportStatus());
      try {
        const exportStatus = await api.loadExportStatus();
        dispatch(new actions.ReceiveExportStatus(exportStatus));
      } catch {
        dispatch(new actions.FailExportStatus());
      }
    }),

  downloadCaseExportPackage: (exportId: string, fileExtension: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      dispatch(new actions.RequestDownloadCaseExportPackage(exportId));
      try {
        const response = await api.downloadCaseExportPackage(exportId);
        downloadFile(response.blob, 'export-case-package-' + exportId + (fileExtension ? '.' + fileExtension : ''));
        dispatch(new actions.ReceiveDownloadCaseExportPackage(exportId));
      } catch (err) {
        dispatch(new ErrorNotification(err.userMessages || err.message));
        dispatch(new actions.FailDownloadCaseExportPackage(exportId));
      }
    }
};
